<template>
    <v-container>
        <v-layout>
            <component :is="current"></component>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    components: {
        en: () =>
            import(
                /* webpackChunkName: "privacy-policies" */ "@/components/privacy-policies/en.vue"
            ),
        de: () =>
            import(
                /* webpackChunkName: "privacy-policies" */ "@/components/privacy-policies/de.vue"
            ),
        fr: () =>
            import(
                /* webpackChunkName: "privacy-policies" */ "@/components/privacy-policies/fr.vue"
            ),
        nl: () =>
            import(
                /* webpackChunkName: "privacy-policies" */ "@/components/privacy-policies/nl.vue"
            ),
    },
    data() {
        return {
            current: "en",
        }
    },
    mounted() {
        if (["en", "de", "fr", "nl"].indexOf(this.$i18n.locale) != -1) {
            this.current = this.$i18n.locale
        } else {
            this.current = "en"
        }
    },
}
</script>
